module.exports = '<svg width="40" height="32" viewBox="0 0 40 32"><path d="M39 12h-3V9a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v3h-3a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h3v3a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-3h3a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1zm-19 6.328V16.89c2.38-1.386 4-3.936 4-6.89V8A8 8 0 0 0 8 8v2c0 2.954 1.62 5.504 4 6.89v1.438C5.102 19.44 0 23.342 0 28v2a2 2 0 0 0 2 2h28a2 2 0 0 0 2-2v-2c0-4.658-5.102-8.56-12-9.672z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/add-user-1.js
// module id = 978
// module chunks = 14